import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import Records from '../views/Records.vue'
import Records2 from '../views/Records2.vue'
import TDsChart from '../components/TDsChart.vue'
import Year from '../views/Year.vue'
import Intro from '../views/Intro.vue'
import yr2001 from '../views/yr2001.vue'
import yr2002 from '../views/yr2002.vue'
import yr2003 from '../views/yr2003.vue'
import yr2004 from '../views/yr2004.vue'
import yr2005 from '../views/yr2005.vue'
import yr2006 from '../views/yr2006.vue'
import yr2007 from '../views/yr2007.vue'
import yr2008 from '../views/yr2008.vue'
import yr2009 from '../views/yr2009.vue'
import yr2010 from '../views/yr2010.vue'
import yr2011 from '../views/yr2011.vue'
import yr2012 from '../views/yr2012.vue'
import yr2013 from '../views/yr2013.vue'
import yr2014 from '../views/yr2014.vue'
import yr2015 from '../views/yr2015.vue'
import yr2016 from '../views/yr2016.vue'
import yr2017 from '../views/yr2017.vue'
import yr2018 from '../views/yr2018.vue'
import yr2019 from '../views/yr2019.vue'
import yr2020 from '../views/yr2020.vue'
import MenuScreen from '../views/MenuScreen.vue'

Vue.use(Router)





export default new Router({
  mode: 'hash',

scrollBehavior (to, from, savedPosition) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ x: 0, y: 0 })
    }, 500)
  })
},

  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/records',
      name: 'records',
      component: Records
    },
    {
      path: '/menu',
      name: 'menu',
      component: MenuScreen
    },
    {
      path: '/charts',
      name: 'TDsChart',
      component: TDsChart
    },
    {
      path: '/records2',
      name: 'records2',
      component: Records2
    },
    {
      path: '/year',
      redirect: '/year/intro',
      component: Year,
      children: [
        {
          path: 'intro',
          component: Intro
        },
        {
          path: '2001',
          component: yr2001
        },
        {
          path: '2002',
          component: yr2002
        },
        {
          path: '2003',
          component: yr2003
        },
        {
          path: '2004',
          component: yr2004
        },
        {
          path: '2005',
          component: yr2005
        },
        {
          path: '2006',
          component: yr2006
        },
        {
          path: '2007',
          component: yr2007
        },
        {
          path: '2008',
          component: yr2008
        },
        {
          path: '2009',
          component: yr2009
        },
        {
          path: '2010',
          component: yr2010
        },
        {
          path: '2011',
          component: yr2011
        },
        {
          path: '2012',
          component: yr2012
        },
        {
          path: '2013',
          component: yr2013
        },
        {
          path: '2014',
          component: yr2014
        },
        {
          path: '2015',
          component: yr2015
        },
        {
          path: '2016',
          component: yr2016
        },
        {
          path: '2017',
          component: yr2017
        },
        {
          path: '2018',
          component: yr2018
        },
        {
          path: '2019',
          component: yr2019
        },
        {
          path: '2020',
          component: yr2020
        },
      ]
    }
  ]

})




// WEBPACK FOOTER //
// ./src/router/index.js